import styles from './InfoBlock.module.scss'

import React from 'react'
import classnames, { Value } from 'classnames'
import LazyImage from '../LazyImage/LazyImage'

interface Props {
    className?: Value
    align?: 'left' | 'right'
    title: string
    description: string
    image: string
}

const InfoBlock: React.FC<Props> = ({ className, align = 'right', title, description, image }) => {
    return (
        <div
            className={classnames(styles.container, className, {
                [styles.left]: align === 'left',
                [styles.right]: align === 'right',
            })}
        >
            <div className={styles.imageContainer}>
                <LazyImage src={image} alt="" className={styles.image} />
            </div>
            <div className={styles.text}>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.description}>{description}</p>
            </div>
        </div>
    )
}

export default InfoBlock
